import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const kegiatan_belajar_mengajar = {
  namespaced: true,
  state: {
    loading: false,
    datas: {},
    event: {},
    my: {},
    students: [],
    queryParam: {},
    modalAbsen: false,
    modalCreate: false,
    tambah_kegiatan: {
      date: null,
    },
    modalUpdate: false,
    reports: [],
  },
  getters: {
    allEvents(state) {
      return state.datas;
    },
    getReports(state) {
      return state.reports;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_EVENT(state, datas) {
      state.event = datas;
    },
    SET_MY(state, datas) {
      state.my = datas;
    },
    SET_STUDENTS(state, datas) {
      state.students = datas;
    },
    SET_MODAL_ABSEN(state, data) {
      state.modalAbsen = data;
    },
    SET_REPORTS(state, data) {
      state.reports = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/event").then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate(
        "backoffice/attendances/student/page",
        payload
      ).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    onRefresh({ state }) {
      store.dispatch("kegiatan_belajar_mengajar/paginate", state.queryParam);
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "Update") {
        if (
          payload[0]["s_hadir"] === 0 &&
          payload[0]["s_sakit"] === 0 &&
          payload[0]["s_izin"] === 0 &&
          payload[0]["s_thadir"] === 0
        ) {
          alerts.sweetalertToast("error", "Santri belum Absen");
          return false;
        } else if (payload[0]["t_hadir"] === "Tidak ada keterangan") {
          alerts.sweetalertToast("error", "Guru belum Absen");
          return false;
        }
        commit("SET_MODAL_ABSEN", true);
        store.dispatch(
          "kegiatan_belajar_mengajar/getEvent",
          payload[0]["event_id"]
        );
        store.dispatch(
          "kegiatan_belajar_mengajar/getStudentEvent",
          payload[0]["event_id"]
        );
      }
    },
    async getEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("backoffice/event/" + payload).then(({ data }) => {
        commit("SET_EVENT", data.record);
        commit("SET_MY", data.account);
        commit("SET_LOADING", false);
      });
    },
    async getStudentEvent({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("students/event/" + payload).then(({ data }) => {
        commit("SET_STUDENTS", data);
        commit("SET_LOADING", false);
      });
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(
        payload[0],
        `kegiatan_belajar_mengajar/${payload[1]}`
      );
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post(
        "backoffice/event/kegiatan-belajar/create",
        payload
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("kegiatan_belajar_mengajar/onRefresh");
          store.dispatch("kegiatan_belajar_mengajar/setState", [
            "modalAbsen",
            false,
          ]);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    setState({ state }, payload) {
      state[payload[0]] = payload[1];
    },
    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      state.tambah_kegiatan.teacher_event = payload;
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        "backoffice/event/" + state.tambah_kegiatan.event_id,
        state.tambah_kegiatan
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("events/onRefresh");
          state.modalUpdate = false;
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async reportPaginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("report/kegiatan-belajar/page", payload).then(
        ({ data }) => {
          commit("SET_REPORTS", data);
          commit("SET_LOADING", false);
        }
      );
    },
  },
};

export default kegiatan_belajar_mengajar;
